export async function getVideoBase64(video: HTMLVideoElement) {
  const canvas = document.createElement('canvas');

  const { videoWidth: width, videoHeight: height } = video;
  canvas.width = width;
  canvas.height = height;
  canvas.getContext('2d')?.drawImage(video, 0, 0, width, height);
  return canvas.toDataURL('image/jpg', 1.0);
}
